<template>
  <div class="main">
    <b-form :class="{'b-layout': true, 'form-geral': true,  'ml-2': true, 'mr-2': true, 'readOnly': readOnly}" @submit.prevent="">
      <p>{{ $t('moagem-prevista') }}</p>
      <div class="box-edit">
        <span>
          <label>{{ $t('moagem-efetiva-ton-dia') }}</label>
          <b-input class="input-pentagro" v-model.lazy="inputLabel.cane.chields.moagem" step="50" min="0" type="number"></b-input>
        </span>
        <span>
          <label>{{ $t('moagem-efetiva-ton-h') }}</label>
          <b-input class="input-pentagro" v-model.lazy="inputLabel.cane.chields.moagemHora" step="50" min="0" type="number"></b-input>
        </span>
      </div>

      <p>{{ $t('qualidade-da-cana') }}</p>
      <div class="box-edit">
        <span>
          <label>{{ $t('fibra') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.fibra" min="8.2" max="100" step="0.1" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('impureza-mineral-kg-tc') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.impureza" min="0" step="0.01" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('pol-0') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.pol" min="8" max="100" step="0.1" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('ar-0') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.ar" min="0.2" max="100" step="0.01" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('pureza-do-caldo') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.purezaCaldo" min="66" max="100" step="0.5" type="number"></b-input>
        </span>

        <span v-if="showStraw"> 
          <label>{{ $t('impureza-vegetal-kg-tc') }} </label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.palha" min="0" type="number"></b-input>
        </span>

        <b-form-checkbox v-if="!readOnly"
          v-model="showStraw"
        >
          {{ $t('habilitar-entrada-de-palha') }}
        </b-form-checkbox>
      </div>

      <p>Clima</p>
      <div class="box-edit">
        <span>
          <label>{{ $t('temperatura-de-bulbo-seco-c') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.cane.chields.temperatura" min="0" type="number"></b-input>
        </span>

        <span>
          <label>{{ $t('umidade-relativa-do-ar') }}</label>
          <b-input class="input-pentagro" v-model="inputLabel.climate.chields.umidadeRelativaAr" min="0" max="100" type="number"></b-input>
        </span>
      </div>

    </b-form>
    <b-form class="ml-3 mr-3" v-if="!readOnly">
      <div>
        <div class="pt-2">
            <label for="select-current">{{ $t('configure-uma-propriedade-da-cana') }}</label>
        </div>

        <!-- CORRENTE -->
        <div class="pt-2">
          <select 
            id="select-current" 
            class="form-control" 
            @change="changeCurrent()" 
            v-model="inputLabel.cane.current"> 
              <option value="" selected>{{ $t('escolha-uma-corrente-0') }}</option>
              <option v-for="(current, index) in currentsCane"
                :key="`node-current-${index}`" :value="current">
                  {{current}}
              </option>
          </select>
        </div>
      </div>

      <div v-if="showStraw">
        <div class="pt-2">
            <label for="select-current">{{ $t('configure-a-corrente-da-palha') }}</label>
        </div>
        <div class="pt-2">
          <select 
            id="select-currentStraw" 
            class="form-control" 
            @change="changeCurrentStraw()" 
            v-model="inputLabel.cane.currentStraw"> 
              <option value="" selected>{{ $t('escolha-uma-corrente-para-palha') }}</option>
              <option v-for="(current, index) in currents"
                :key="`node-current-${index}`" :value="current">
                  {{current}}
              </option>
          </select>
        </div>
        <!--/CORRENTE -->
      </div>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import { urlMainAPI, defaultSuccess } from "@/global";
import { SingletonEnginnering } from "../_service/singletonEngineering"
import { NumberFormat ,ParseToNumber } from "../../utils/tools"
import { WaitMixin } from "../../../mixins/waitMixin"

  export default {
    props: {
      node: {
        type: Object,
        default: null
      },
      importONLS: {
        type: Number
      },
      readOnly:{
      type: Boolean,
      default: false,
    }
    },

    mixins: [ WaitMixin ],

    data() {
      return {
        firstLoad: true,
        showStraw: this.node.showStraw,
        straw: {},
        currentsCane: SingletonEnginnering.currents.filter(cr => String(cr).match(/\b1_.+/g)),
        currents: SingletonEnginnering.currents,
        operations: [
            ...SingletonEnginnering.operations.filter(op => String(op).match(/\bTorreResfriamento/g)), 
            ...SingletonEnginnering.operations.filter(op => String(op).match(/\bEvaporativeCondenser/g))
        ],
        inputLabel: {
          cane: { 
            caption: 'Qualidade da cana',
            attrs: [],
            current: '',
            currentStraw: '',
            chields: {
              moagem: 0,
              moagemHora: 0,
              temperatura: 0,
              fibra: 0, 
              impureza: 0,
              pol: 0,
              ar: 0,
              purezaCaldo:  0,
              palha: 0,
            }
          },
          climate: { 
            caption: 'Clima',
            attrs: [],
            operation: '',
            chields: {
              tempBulboSeco: 0,
              umidadeRelativaAr: 0
            }
          }
        }
      }
    },

    watch:{
      "inputLabel.cane.chields.moagem"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "W" && a.observation)
            a.value = NumberFormat(value / 24)
            this.inputLabel.cane.chields.moagemHora = value / 24
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.moagemHora"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "W" && a.observation)
            a.value = NumberFormat(value)
            this.inputLabel.cane.chields.moagem = value * 24
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.temperatura"(value){
        if(this.firstLoad) return
        let temp = 0;
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "T"){
            temp = NumberFormat(value)
            a.value = temp
          }
        })

        this.inputLabel.climate.attrs.forEach(a => {
          if(a.key == "TBS")
            a.value = temp
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.fibra"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "fracaoMassica" && a.propName == "Fibra"){
            a.value = value
          }
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.impureza"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "fracaoMassica" && a.propName == "Terra")
            a.value = NumberFormat(value / 10)
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.pol"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "POL")
            a.value = NumberFormat(value)
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.ar"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "AR")
            a.value = NumberFormat(value)
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.purezaCaldo"(value){
        if(this.firstLoad) return
        this.inputLabel.cane.attrs.forEach(a => {
          if(a.key == "pureza")
            a.value = NumberFormat(value)
        })
        this.updateNode();
      },

      "inputLabel.cane.chields.palha"(value){
        if(this.firstLoad) return
        this.straw.value = NumberFormat(value);
        this.updateNode();
      },

      "inputLabel.climate.chields.umidadeRelativaAr"(value){
        if(this.firstLoad) return
        this.inputLabel.climate.attrs.forEach(a => {
          if(a.key == "Umidade") {
            a.value = NumberFormat(value)
          }
        })
         
        this.updateNode();
      },

      showStraw(){
        this.updateNode(); 
      },

      importONLS(){
        this.waitOn()
        const listTags = [  
                            'input_online_Moagem',
                            'input_online_POL',
                            'input_online_AR',
                            'input_online_Pureza',
                            'input_online_Fibra',
                            'input_online_Impureza',
                            'input_online_Palha',
        ]
        defaultSuccess(this.$t('importando-dados-do-processo'))
        console.log('Importar dados da cana :>> ', listTags);
        axios.post(`${urlMainAPI}/getsugarcanequality`, listTags).then(resp => {
          if(resp.status == 200)
            defaultSuccess(this.$t('dados-importados-com-sucesso'))

            let result = resp.data
            this.inputLabel.cane.chields.moagem = parseFloat(result[listTags[0]]) * 24
            this.inputLabel.cane.chields.moagemHora = parseFloat(result[listTags[0]])
            this.inputLabel.cane.chields.pol = parseFloat(result[listTags[1]])
            this.inputLabel.cane.chields.ar = parseFloat(result[listTags[2]])
            this.inputLabel.cane.chields.purezaCaldo =  parseFloat(result[listTags[3]])
            this.inputLabel.cane.chields.fibra = parseFloat(result[listTags[4]])
            this.inputLabel.cane.chields.impureza =  parseFloat(result[listTags[5]])
            this.inputLabel.cane.chields.palha = parseFloat(result[listTags[6]])
            this.waitOff()
            
            
        }).catch(err => {console.log(err);  this.waitOff()})
      },
    },

    methods: {
      loadNode(){
        this.firstLoad = true;
        let attrs = new Array()
        this.inputLabel.cane.attrs = [];
        this.node.data.forEach((a) => {
            if(a.key == "W" && a.observation) {
              this.inputLabel.cane.chields.moagem = ParseToNumber(NumberFormat(a.value)) * 24
              this.inputLabel.cane.chields.moagemhora = ParseToNumber(NumberFormat(a.value))
            }
            if(a.key == "T") this.inputLabel.cane.chields.temperatura = ParseToNumber(a.value)
            if(a.key == "fracaoMassica" && a.propName == "Fibra") this.inputLabel.cane.chields.fibra = ParseToNumber(a.value)
            if(a.key == "fracaoMassica" && a.propName == "Terra") this.inputLabel.cane.chields.impureza = ParseToNumber(NumberFormat(a.value)) * 10
            if(a.key == "POL") this.inputLabel.cane.chields.pol = ParseToNumber(a.value)
            if(a.key == "AR") this.inputLabel.cane.chields.ar = ParseToNumber(a.value)
            if(a.key == "pureza") this.inputLabel.cane.chields.purezaCaldo = ParseToNumber(a.value)
            if(a.key == "TBS") this.inputLabel.climate.chields.tempBulboSeco = ParseToNumber(a.value)
            if(a.key == "Umidade") this.inputLabel.climate.chields.umidadeRelativaAr = ParseToNumber(a.value)

            if(a.key == "W" && !a.observation){
              this.inputLabel.cane.chields.palha = ParseToNumber(a.value)
              this.inputLabel.cane.currentStraw = a.index
              this.straw = a
            } 
            else if(a.key != "TBS" && a.key != "Umidade")
              attrs.push(a)

            if(!this.inputLabel.cane.current && a.observation)
              this.inputLabel.cane.current = attrs[0].index
        });
        this.inputLabel.cane.attrs = attrs;
        this.firstLoad = false;
      },

      updateNode(){
        if(this.firstLoad) return;
        this.node.attrs = [...this.inputLabel.cane.attrs, ...this.inputLabel.climate.attrs]
        this.node.showStraw = this.showStraw;
        if(this.showStraw && this.straw){
          this.node.attrs = [...this.node.attrs, this.straw];
        }
      },

      changeCurrentStraw(){
        let props = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.cane.currentStraw, {name: "Atributos", index: 0});
        props.forEach(p => {
          if(p.key == "W"){
            this.straw = p
            this.inputLabel.cane.chields.palha = ParseToNumber(p.value)
          }
        })
      },

      changeCurrent(){
        let props = SingletonEnginnering.getCurrentProperties(this.inputLabel.cane.current);
        this.inputLabel.cane.attrs = new Array();

        props.forEach(prop => {
          if(prop.name == "Atributos"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.cane.current, prop)
            console.log("Attr =>", attrs)

            attrs.forEach(attr => {
              if(attr.key == "W"){
                this.inputLabel.cane.chields.moagem = ParseToNumber(NumberFormat(attr.value)) * 24
                this.inputLabel.cane.chields.moagemHora = ParseToNumber(NumberFormat(attr.value))
                attr.observation = "cana"
                this.inputLabel.cane.attrs.push(attr)
              }

              if(attr.key == "POL"){
                this.inputLabel.cane.chields.pol = ParseToNumber(attr.value)
                this.inputLabel.cane.attrs.push(attr)
              }

              if(attr.key == "AR"){
                this.inputLabel.cane.chields.ar = ParseToNumber(attr.value)
                this.inputLabel.cane.attrs.push(attr)
              }

              if(attr.key == "T"){
                this.inputLabel.cane.chields.temperatura = ParseToNumber(attr.value)
                this.inputLabel.cane.attrs.push(attr)
              }
            })
          }

          if(prop.name == "Caldo"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.cane.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "pureza"){
                this.inputLabel.cane.chields.purezaCaldo = ParseToNumber(attr.value)
                this.inputLabel.cane.attrs.push(attr)
              }
            })
          }

          if(prop.name == "Fibra"){
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.cane.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "fracaoMassica"){
                this.inputLabel.cane.chields.fibra = ParseToNumber(attr.value)
                this.inputLabel.cane.attrs.push(attr)
              }
            })
          }

          if(prop.name == "Terra"){ 
            let attrs = SingletonEnginnering.getCurrentPropertiesAttributes(this.inputLabel.cane.current, prop)
            attrs.forEach(attr => {
              if(attr.key == "fracaoMassica"){
                this.inputLabel.cane.chields.impureza = ParseToNumber(attr.value) * 10
                this.inputLabel.cane.attrs.push(attr)
              }
            })
          }
        })

        this.updateNode()
      },

      async loadTowers(){
        let attrs = []
        this.operations.forEach(tower => {
          attrs = [...SingletonEnginnering.getOperationsProperties(tower), ...attrs];
        })
        this.inputLabel.climate.attrs = new Array()

        attrs.forEach(attr => {
          if(attr.caption == "TBS"){
            this.inputLabel.climate.attrs.push(attr)
          }

          if(attr.caption == "Umidade"){
            this.inputLabel.climate.chields.umidadeRelativaAr = ParseToNumber(attr.value)
            this.inputLabel.climate.attrs.push(attr)
          }
        })
      },
    },
    
    mounted(){ 
      this.loadTowers();
      this.loadNode();
    },

    destroyed() {
      this.waitOff();
    },
  }
</script>

<style scoped>

.main{
  display: flex;
  font-size: 0.9rem;
}

.form-geral{
  width: 345px;
}

form{
  color: #0009;
}

.form-geral>p{
  display: inline;
  position: relative;
  padding: 4px;
  top: 9px;
  font-weight: bold;
  margin: 5px 0px 0px 3px;
  background-color: white;
}

.box-edit{
  padding: 8px;
  box-shadow: 0px 0px 3px #0008;
  border-radius: 3px;
}

.box-edit>span{
  display: flex;
  justify-content: space-between;
}

.box-edit>span>input{
  width: 115px;
  height: 20px;
  text-align: right;
  border: #ff5f00 solid 1px;
}

.box-edit>span>label{
  margin-left: 5px;
  margin-bottom: 2px;
}


.box-edit>span>input:focus{
  box-shadow: 0px 0px 5px #ff5f00;
}

.form-geral.readOnly>p{
  background-color: rgb(250, 250, 250)
}

</style>